import { render, staticRenderFns } from "./BtnDocDown.vue?vue&type=template&id=c22a3a74&scoped=true"
import script from "./BtnDocDown.vue?vue&type=script&lang=js"
export * from "./BtnDocDown.vue?vue&type=script&lang=js"
import style0 from "./BtnDocDown.vue?vue&type=style&index=0&id=c22a3a74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a3a74",
  null
  
)

export default component.exports